import { Row } from 'antd';
import React, { Component } from 'react';
import RowItem from './RowItem';
import './styles.css';
import { GSTPaidFlagCountries } from './../../../../../services/fieldRequired';

class Items extends Component {
    renderRow = () => {
        return this.props.items.map((value, key) => {
            return <RowItem
                shipment={this.props.shipment}
                itemData={value}
                key={key}
                no={key + 1}
            />
        })
    }

    render() {        
        const { shipment } = this.props
        let showGSTPaid = false
        if(GSTPaidFlagCountries.includes(shipment.DestinationCountryCH)){
            showGSTPaid = true
        }
        return (
            <div className="item-talbe" id="item-information">
                <div className="warp-title">
                    <Row>
                        <h1 className='title'>Item Information</h1>
                    </Row>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>NO</th>
                            <th>SKU</th>
                            <th>CHANNEL ITEM CODE</th>
                            <th>ITEM NAME(EN)</th>
                            {/* <th className='cols-item-discount'>&nbsp;</th> */}
                            <th>DECLARED VALUE</th>
                            <th>QTY</th>
                            <th>TOTAL VALUE</th>
                            <th>ORIGIN</th>
                            <th>CHANNEL ORD. ITEM #</th>
                            {showGSTPaid ? <th>GST Paid</th> : ''}
                        </tr>
                    </thead>
                    <tbody>{this.renderRow()}</tbody>
                </table>
            </div>
        )
    }
}

export default Items



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/items/index.js